export function gradesToLabels(grades) {
  return grades?.map((grade) => gradeLabel(grade)) || []
}

export function gradeLabel(grade) {
  if (grade === 'Adult-Transition') {
    return 'Adult Transition'
  }
  return grade
}

/**
 * Converts a grade label from summary format (e.g., "1st Grade", "Kindergarten") 
 * to Browse Goals format (e.g., "1", "K")
 * @param {string} gradeLabel - The grade label from summary (e.g., "1st Grade", "Kindergarten")
 * @returns {string} The grade value for Browse Goals (e.g., "1", "K")
 */
export function PLWGradeLabelToBrowseGoalsValue(gradeLabel) {
  const mapping = {
    'Birth-3': 'Birth-3',
    'Pre-Kindergarten': 'Pre-K',
    'Kindergarten': 'K',
    '1st Grade': '1',
    '2nd Grade': '2',
    '3rd Grade': '3',
    '4th Grade': '4',
    '5th Grade': '5',
    '6th Grade': '6',
    '7th Grade': '7',
    '8th Grade': '8',
    '9th Grade': '9',
    '10th Grade': '10',
    '11th Grade': '11',
    '12th Grade': '12'
  }
  
  return mapping[gradeLabel] || gradeLabel
}